/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
/**
 * Bid matrix plant parts -> bnCRM Plant_Configuration__c picklist values. The pricing contract,
 * the review form and confirmation all use the bnCRM spelling.
 */
export const PLANT_CONFIGURATION_SF_VALUES = {
    PV: 'PV',
    BESS: 'BESS',
    WIND: 'Wind',
    H2: 'H2ES',
};
/**
 * Pricing inputs the bid matrix already defines (same mapping as the former Excel upload
 * template). The upload UI locks them and the server overwrites them on confirm, so submitted
 * values can never diverge from the bid matrix. Prices stay with Finance.
 */
export function matrixPricingValues(scenario) {
    if (!scenario)
        return {};
    const values = {
        Plant_Configuration__c: scenario.plant_type
            .split('+')
            .flatMap((part) => PLANT_CONFIGURATION_SF_VALUES[part] ?? []),
        COD__c: scenario.cod ? scenario.cod.slice(0, 10) : null,
        Interconnection_Size_MW_ac__c: scenario.poi_mw_ac,
        PV_Inverter_Capacity_MW_ac__c: scenario.pv_ac_capacity,
        Li_ion_Storage_Power_MW_ac__c: scenario.ess_power,
        Li_ion_Storage_Capacity_MWh_ac__c: scenario.ess_capacity,
        BESS_Cycles__c: scenario.ess_cycles,
        Wind_Capacity_MW_ac__c: scenario.wind_capacity,
        Delivery_Point__c: scenario.delivery_point,
        PV_PPA_Term__c: scenario.contracted_term,
        BESS_Term__c: scenario.ess_term,
    };
    // Only lock what the matrix actually specifies.
    return Object.fromEntries(Object.entries(values).filter(([, value]) => value != null && value !== ''));
}
//# sourceMappingURL=matrix.js.map